// ─── Page Text ────────────────────────────────────────────────────────────────

export const TEXT = {
  PAGE_TITLE: "Skills Bridger",
  PAGE_DESCRIPTION:
    'Skills Bridger measures aggregated skills gaps as "Skills you have v/s Skills you need" and is available at all levels, from individuals to groups. Use dropdown filters to select a group of employees. Click rows for individual employee skills insights.',
  ACTION_SKILLS_MAP_LABEL:          "Skills Map for selected group:",
  ACTION_SKILLS_MAP_BTN:            "Group Skills Map",
  ACTION_SKILLS_PROFICIENCY_LABEL:  "Skills Proficiency for selected group:",
  ACTION_SKILLS_PROFICIENCY_BTN:    "Group Skills Proficiency",
  JD_MISMATCH_TITLE:                "Mismatched Job",
  JD_MISMATCH_DESC:                 "Selected employees' JD is not the same. Please select employees with the same job.",
};

// ─── Routes ───────────────────────────────────────────────────────────────────

export const ROUTE = {
  GROUP_SKILLS_MAP:         "/skills-bridger/group-skills-map",
  GROUP_SKILLS_PROFICIENCY: "/Skills-bridger/group-skills-proficiency",
  EMPLOYEE_SKILLS_MAP:      "/skills-bridger/employee-skills-map",
};
